import { Injectable } from '@angular/core';
import * as debug from 'debug';
import { CrudApiProvider } from '../crud-api/crud-api';
import { UserProvider } from '../user/user';

@Injectable()
export class SettingsProvider {
  log = debug('app:SettingsProvider');

  prefix = 'settings-';
  keyMappings = {
    NAVIGATION_MODE: 'NAVIGATION_MODE',
    zoomLevel: 'zoomLevel',
  };

  // default is LOCAL_STORAGE
  settingTypes = {
    feedContent: 'USER_COLLECTION',
  };

  tools: any; //recursive dependency set by tools provier

  getters = {
    LOCAL_STORAGE: this.getLocalStorage,
    USER_COLLECTION: this.getUserCollection,
  };
  setters = {
    LOCAL_STORAGE: this.setLocalStorage,
    USER_COLLECTION: this.setUserCollection,
  };

  defaultFeedContentSettings = {
    OTHER: 'ASK_SENSITIVE',
    OTHER_CONTROVERSIAL: 'HIDE',
    POLITICS: 'HIDE',
    SEX: 'HIDE',
    VIOLENCE: 'HIDE',
  };

  user; // passed in cause a circular dep

  constructor(public crud: CrudApiProvider) {
    this.log('init SettingsProvider');
  }

  get(key: string, fallback?): any {
    const getter = this.getters[this.settingTypes[key] || 'LOCAL_STORAGE'];
    return getter.apply(this, arguments);
  }

  set(key: string, value: any) {
    try {
      this.tools.logAnalyticsEvent('trackCustom', 'settings-updated-' + key, {
        value,
      });
    } catch (e) {}

    const setter = this.setters[this.settingTypes[key] || 'LOCAL_STORAGE'];
    return setter.apply(this, arguments);
  }

  getLocalStorage(key: string, fallback?): any {
    var x = localStorage.getItem(this.getKey(key));

    if (x) {
      try {
        return JSON.parse(x);
      } catch (e) {
        return x || fallback || undefined;
      }
    } else {
      return x || fallback || undefined;
    }
  }

  setLocalStorage(key: string, value: any) {
    localStorage.setItem(this.getKey(key), JSON.stringify(value));
  }

  getUserCollection(key: string, fallback?): any {
    return this.user.get(`settings.${key}`) || fallback;
  }

  setUserCollection(key: string, value: any): any {
    this.user.set(`settings.${key}`, value);

    this.crud
      .put(`/api/users/${this.user.get('_id')}/settings`, {
        key,
        value,
      })
      .catch(e => {
        console.warn('error updating settings', e);
        this.user.set(`settings.${key}`, value);
      });
  }

  getKey(key: string) {
    return this.keyMappings[key] || this.prefix + key;
  }
}



// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts